import React, { useEffect, useState } from 'react';
import { Modal, Checkbox, List, Spin, Button, Row, Col, Typography, Alert, Space } from 'antd';
import { useSelector } from 'react-redux';

const { Text } = Typography;

const ConfirmTrackingModal = ({ visible, onOk, onCancel, loading }) => {
  const sellerAccounts = useSelector(state => state.dataCommon.sellerAccounts);
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    if (visible && sellerAccounts) {
      setSelectedIds(sellerAccounts.map(acc => acc.id)); // Default select all
    }
  }, [visible, sellerAccounts]);

  const onChange = (checkedValues) => {
    setSelectedIds(checkedValues);
  };

  const handleOk = () => {
    onOk(selectedIds);
  };

  return (
    <Modal
      title="Xác nhận vận chuyển với Amazon"
      open={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText="Xác nhận"
      cancelText="Hủy"
      confirmLoading={loading}
      width={600}
    >
      <Space direction="vertical" style={{ width: '100%' }} size="large">
        <Alert
          message="Thông tin"
          description="Tự động xác nhận vận chuyển (confirm shipment) cho các đơn hàng đã có tracking number và đáp ứng điều kiện. Hệ thống sẽ kiểm tra và gửi thông tin tracking lên Amazon cho các đơn hàng đã được ship."
          type="info"
          showIcon
        />
        
        <div>
          <Text strong>Seller Accounts:</Text>
          {sellerAccounts.length === 0 ? (
            <Spin />
          ) : (
            <>
              <Row gutter={8} style={{ marginTop: 8, marginBottom: 8 }}>
                <Col>
                  <Button size="small" onClick={() => setSelectedIds(sellerAccounts.map(acc => acc.id))}>
                    Chọn tất cả
                  </Button>
                </Col>
                <Col>
                  <Button size="small" onClick={() => setSelectedIds([])}>
                    Bỏ tất cả
                  </Button>
                </Col>
              </Row>
              <Checkbox.Group
                style={{ width: '100%' }}
                value={selectedIds}
                onChange={onChange}
              >
                <List
                  dataSource={sellerAccounts}
                  renderItem={item => (
                    <List.Item>
                      <Checkbox value={item.id}>
                        {item.name} ({item.sellerId})
                      </Checkbox>
                    </List.Item>
                  )}
                />
              </Checkbox.Group>
            </>
          )}
        </div>
      </Space>
    </Modal>
  );
};

export default ConfirmTrackingModal;
